/**
 * Cucs-advising route constants
 */

export const ADMIN_AUTH_ROUTES = {
  LOGIN: '/apps/cucs-advising/login',
  RESET_PASSWORD: '/apps/cucs-advising/reset-password',
} as const;

export const ADMIN_ROUTES = {
  BASE: '/apps/cucs-advising/admin',
  OVERVIEW: '/apps/cucs-advising/admin/overview',
  SUPPORT: '/apps/cucs-advising/admin/support',
  QA_MANAGEMENT: '/apps/cucs-advising/admin/qa_management',
} as const;

export const isProtectedRoute = (path: string): boolean => {
  return path.startsWith(ADMIN_ROUTES.BASE) && path !== ADMIN_AUTH_ROUTES.LOGIN;
};

export const getDefaultAdminRoute = (): string => {
  return ADMIN_ROUTES.OVERVIEW;
};
